var exports = {
  "kL": "x9245d464--0a77df--container",
  "Sl": "x9245d464--0a77df--image",
  "Qs": "x9245d464--0a77df--content",
  "XI": "x9245d464--0a77df--action",
};

module.exports = exports;
